<template>
    <div class="content">
        <div
            class="read"
            v-if="info.explainNames !== undefined && info.explainNames.length > 0"
        >
            <span>请先阅读</span>
            <a
                id="tioakuanxieyi"
                @click="xieyi(item.explainType)"
                v-for="(item, index) in info.explainNames"
                :key="index"
                >《{{ item.explainTypeName }}》</a
            >
        </div>
        <van-action-sheet
            v-model="fuwuxieyi"
            :close-on-click-overlay="false"
            @cancel="cancel"
            :close-icon="require('../img/ico_close.svg')"
            :title="
                actionEvent == '1'
                    ? '健康告知书'
                    : actionEvent == '2'
                    ? '保险条款'
                    : actionEvent == '3'
                    ? '服务说明'
                    : '投保须知'
            "
            class="fuwuxieyi"
            id="xieyineirong"
        >
            <div class="actionSheetContent">
                <van-tabs
                    v-model="active"
                    title-active-color="#333"
                    title-inactive-color="#888"
                    @click="onClickTop"
                >
                    <van-tab
                        v-for="(item, index) in tab"
                        :key="index"
                        :title="item.packageName"
                    >
                        <div
                            class="ql-editor"
                            v-html="item.content"
                            ref="TOP"
                            style="max-height: 4.7rem; overflow-y: scroll"
                        ></div>
                    </van-tab>
                </van-tabs>
                <div class="btn" id="jiankangqueren" v-if="xiadanqueren">
                    <a class="flex" @click="fuwuxieyi = false">部分是</a>
                    <a class="flex" v-if="button == '1'" @click="orderSubmitUrl()"
                        >全部否</a
                    >
                    <a class="flex" v-if="button == '2'" @click="xiadan2()">全部否</a>
                </div>
            </div>
        </van-action-sheet>
    </div>
</template>
<script>
export default {
    props: {
        type: String,
        button: String,
        isAgent: String,
        goodsBargain: Object,
        info: Object,
    },
    data() {
        return {
            fuwuxieyi: false, //协议是否显示
            xiadanqueren: false, //协议操作按钮是否显示
            active: 0, //详情tab切换活动下标
            tab: [],
            actionEvent: '', //当前协议内容：1:健康告知，2:保险条款，3:服务说明 其他：投保须知
            //querenkuang:false,
            yuanjia: false,
        };
    },
    created() {},
    computed: {
        querenkuang: function () {
            return this.info.explainNames.some(function (item, index, array) {
                return item.explainType == '1';
            });
        },
    },
    methods: {
        orderSubmitUrl() {
            //分销2.11 是否允许店员自购
            // if (this.info.canBuy === '0') {
            //     this.$toast.fail('当前商品不允许店员自己购买');
            //     return;
            // }
            this.fuwuxieyi = false;
            this.xiadanqueren = false;
            const {userNotify}=this.info

            if (userNotify) {
                this.$parent.$refs.actionRef.userTold = true
            }else{
                 window.location.href = this.info.orderSubmitUrl;
            }

            let { channel, shareMemberId, sellType, sellLabel } = this.$route.query;

            if (this.button == '1') {
                this.$trackFn.send('click_material', {
                    // 原价购买点击 - 埋点
                    page_type: 'good_detailh5',
                    page_attr: 'normal',
                    card_type: 'bottom_bar',
                    item_id: this.info.skuNo,
                    item_type: 'product_id',
                    sell_type: sellType,
                    sell_label: sellLabel,
                    sell_from:
                        JSON.parse(sessionStorage.getItem('user')).channelType == 'app'
                            ? 'yljkapp'
                            : JSON.parse(sessionStorage.getItem('user')).channelType ==
                              'assistant'
                            ? 'ydbapp'
                            : 'wx_off',
                    material_type: 'popup',
                    material_link: this.info.orderSubmitUrl,
                });
            }
            if (this.button == '2') {
                this.$trackFn.send('click_material', {
                    page_type: 'good_detailh5',
                    page_attr: this.goodsBargain
                        ? this.info.goodsStatus == '1'
                            ? this.goodsBargain.userBargainStatus == '0'
                                ? 'no_started'
                                : this.goodsBargain.userBargainStatus == '3'
                                ? 'finished'
                                : 'ongoing'
                            : 'off_shelf'
                        : 'normal',
                    item_id: this.info.skuNo,
                    item_type: 'product_id',
                    card_type: 'bottom_bar',
                    card_id: shareMemberId,
                    sell_type: sellType,
                    sell_label: sellLabel,
                    sell_from:
                        JSON.parse(sessionStorage.getItem('user')).channelType == 'app'
                            ? 'yljkapp'
                            : JSON.parse(sessionStorage.getItem('user')).channelType ==
                              'assistant'
                            ? 'ydbapp'
                            : 'wx_off',
                    material_type: 'original_price',
                    material_link: this.info.orderSubmitUrl,
                });
            }
        },
        cancel() {
            this.xiadanqueren = false;
            this.active = 0;
        },
        xiadan2() {
            if (this.yuanjia) {
                this.orderSubmitUrl();
            } else {
                this.$emit('noticeParent1', 'xiadan');
            }
        },
        xieyi(event) {
            this.actionEvent = event;
            const { goodsType, explainNames } = this.info;
            if (goodsType === '9') {
                const result = explainNames.filter(record=>record.explainType === event);
                this.tab = result&&result[0].items;
            } else {
                this.$api
                    .explain({ explainType: event, refNo: this.info.subGoodsRefNo })
                    .then((res) => {
                        if (res.errno == '0') {
                            this.tab = res.data.body;
                        }
                    });
            }
            this.fuwuxieyi = true;
            let { channel, shareMemberId, sellType, sellLabel } = this.$route.query;
            this.$trackFn.send('click_material', {
                page_type: 'good_detailh5',
                page_attr: this.goodsBargain
                    ? this.info.goodsStatus == '1'
                        ? this.goodsBargain.userBargainStatus == '0'
                            ? 'no_started'
                            : this.goodsBargain.userBargainStatus == '3'
                            ? 'finished'
                            : 'ongoing'
                        : 'off_shelf'
                    : 'normal',
                item_id: this.info.skuNo,
                item_type: 'product_id',
                card_type:
                    event == '1'
                        ? 'inform'
                        : event == '2'
                        ? 'clause'
                        : event == '3'
                        ? 'agreement'
                        : 'insure',
                card_id: shareMemberId,
                sell_type: sellType,
                sell_label: sellLabel,
                sell_from:
                    JSON.parse(sessionStorage.getItem('user')).channelType == 'app'
                        ? 'yljkapp'
                        : JSON.parse(sessionStorage.getItem('user')).channelType ==
                          'assistant'
                        ? 'ydbapp'
                        : 'wx_off',
                material_type: 'popup',
            });
            this.$trackFn.send('click_material', {
                page_type: 'good_detailh5',
                page_attr:
                    this.button == '1'
                        ? 'normal'
                        : this.info.goodsStatus == '1'
                        ? this.goodsBargain.userBargainStatus == '0'
                            ? 'no_started'
                            : this.goodsBargain.userBargainStatus == '3'
                            ? 'finished'
                            : 'ongoing'
                        : 'off_shelf',
                item_id: this.info.skuNo,
                item_type: 'product_id',
                card_type:
                    event == '1'
                        ? 'inform'
                        : event == '2'
                        ? 'clause'
                        : event == '3'
                        ? 'agreement'
                        : 'insure',
                card_id: shareMemberId,
                sell_type: sellType,
                sell_label: sellLabel,
                sell_from:
                    JSON.parse(sessionStorage.getItem('user')).channelType == 'app'
                        ? 'yljkapp'
                        : JSON.parse(sessionStorage.getItem('user')).channelType ==
                          'assistant'
                        ? 'ydbapp'
                        : 'wx_off',
                material_type: 'close',
            });
            setTimeout(() => {
                this.$nextTick(() => {
                    this.$trackFn.load('xieyineirong', 'view_material', {
                        // 发起砍价中间曝光 - 埋点
                        page_type: 'good_detailh5',
                        page_attr:
                            this.button == '1'
                                ? 'normal'
                                : this.info.goodsStatus == '1'
                                ? this.goodsBargain.userBargainStatus == '0'
                                    ? 'no_started'
                                    : this.goodsBargain.userBargainStatus == '3'
                                    ? 'finished'
                                    : 'ongoing'
                                : 'off_shelf',
                        card_type:
                            event == '1'
                                ? 'inform'
                                : event == '2'
                                ? 'clause'
                                : event == '3'
                                ? 'agreement'
                                : 'insure',
                        card_id: shareMemberId,
                        item_id: this.info.skuNo,
                        item_type: 'product_id',
                        sell_type: sellType,
                        sell_label: sellLabel,
                        sell_from:
                            JSON.parse(sessionStorage.getItem('user')).channelType ==
                            'app'
                                ? 'yljkapp'
                                : JSON.parse(sessionStorage.getItem('user'))
                                      .channelType == 'assistant'
                                ? 'ydbapp'
                                : 'wx_off',
                        material_type: 'popup',
                    });
                });
            }, 1000);
        },
        onClickTop() {
            if (this.$refs.TOP[this.active]) {
                this.$refs.TOP[this.active].scrollTo(0, 0);
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.content {
    .read {
        text-align: left;
        font-size: 0.225rem;
        padding-bottom: 15px;
        span {
            color: #888888;
        }
        a {
            color: #00b095;
        }
    }

    .flex {
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .fuwuxieyi {
        border-radius: 40px 40px 0px 0px !important;

        ::v-deep.van-action-sheet__header {
            position: relative;
            text-align: left;
            font-size: 0.36rem;
            line-height: 0.48rem;
            font-weight: 600;
            color: #333333;
            padding-left: 0.4rem;
            margin-top: 0.38rem;
            padding-bottom: 0.1rem;
            .van-icon__image {
                width: 0.48rem;
                height: 0.48rem;
            }
        }
        ::v-deep.van-card {
            background: #fff;
            padding: 0.4rem 0;
            border-top: 1px solid #eee;
        }
        ::v-deep.van-card__title {
            font-size: 0.28rem;
            font-weight: 500;
            color: #333333;
        }
        ::v-deep.van-card__price {
            color: #dd2b1e;
        }
        ::v-deep.van-card__num {
            margin-top: -1.4rem;
            color: #333333;
        }
    }
    .actionSheetContent {
        margin: 0.4rem;
        ::v-deep {
            .van-tab {
                flex: none !important;
            }
            .van-tabs__wrap {
                height: 1rem;
                margin-bottom: 0.4rem;
                //   border-bottom: 1px solid #eee;
            }
            .van-tab__text {
                font-size: 0.3rem;

                font-family: PingFangSC-Medium, PingFang SC;
            }
            .van-tabs__line {
                width: 1.28rem;
                height: 0.06rem;
                background: linear-gradient(124deg, #f26b57 0%, #f83a2c 100%);
                border-radius: 0.03rem;
            }
        }
        .btn {
            display: flex;
            justify-content: space-between;
            padding-top: 0.5rem;
            a {
                width: 3rem;
                height: 0.88rem;
                font-size: 36px;
                font-family: PingFangSC-Medium, PingFang SC;
                border-radius: 16px;
                &:first-child {
                    color: #dd2b1e;
                    background: linear-gradient(
                        90deg,
                        rgba(240, 86, 64, 0.05) 0%,
                        rgba(221, 43, 30, 0.05) 100%
                    );
                }
                &:last-child {
                    color: #ffffff;
                    background: linear-gradient(128deg, #f26b57 0%, #dd2b1e 100%);
                    box-shadow: 0px 8px 16px 0px rgba(224, 32, 32, 0.3);
                }
            }
        }
    }
}
</style>
